export const saveUserToLocal = (user, saveToken) => {
  user['role'] = user['role'];

  localStorage.setItem('user-email', user['email']);
  if (saveToken) localStorage.setItem('user-token', user['token']);
  localStorage.setItem('user-name', user['name']);
  localStorage.setItem('user-role', user['role']);
  localStorage.setItem('user-org-name', user?.['organization']?.['name']);
  localStorage.setItem('user-phone', user['phone']);

  const requiredFields = ['name', 'email', 'phone', 'role', 'token', '_id', 'organization', 'hasFinancialIntelligenceAccess'];
  const userJSON = {};
  requiredFields.forEach(f => (userJSON[f] = user[f]));
  localStorage.setItem('user', JSON.stringify(userJSON));
};

export function getProfileData() {
  return JSON.parse(localStorage.getItem('user'));
}
